import { render, staticRenderFns } from "./TaskOverview.vue?vue&type=template&id=368319d1&scoped=true"
import script from "./TaskOverview.vue?vue&type=script&lang=ts"
export * from "./TaskOverview.vue?vue&type=script&lang=ts"
import style0 from "./TaskOverview.vue?vue&type=style&index=0&id=368319d1&prod&lang=scss"
import style1 from "./TaskOverview.vue?vue&type=style&index=1&id=368319d1&prod&lang=scss"
import style2 from "./TaskOverview.vue?vue&type=style&index=2&id=368319d1&prod&scoped=true&lang=css"
import style3 from "./TaskOverview.vue?vue&type=style&index=3&id=368319d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368319d1",
  null
  
)

export default component.exports